import { PlacementInterface } from '../../../interfaces/placement.interface';

export class PickPlacement {
    public static readonly type = '[JobsPlacements] Pick a placement';

    constructor(public placement: PlacementInterface | null) {}
}
